import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Grid, Tooltip } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import BarIcon from '../../asset/image/NewBarIcon.svg';
import PieIcon from '../../asset/image/NewPieIcon.svg';
import newDownloadButton from '../../asset/image/NewDownloadButton.svg';
import upArrow from '../../asset/image/newUpArrow.svg';
import downArrow from '../../asset/image/newDownArrow.svg';
import CircleIcon from '@mui/icons-material/Circle';
import _ from "lodash";
import { getDecodeURI, getEncodedURI } from "../../utils/util";
import { useState } from "react";

const AnalyticsBarChart = (props) => {
    const { barChartData, chartType, setChartType, location, history } = props;
    
    const totalUsage = barChartData?.reduce((acc, item) => acc + item.y, 0) || 1;
    const [titleLeft, setTitleLeft] = useState(0);

    const colors = ['#2f2282', '#1b51a7', '#3dab97', '#5e3f9e', '#3e88d3', '#1d136a', '#69b8e5', '#3f79ca', '#9e8cc5', '#ed9340',
        '#8cafdf', '#d9914f', '#86c6df', '#3c7df1', '#61cdc0', '#64a1f4', '#dc6161', '#146680', '#2039b5', '#00ad64',
        '#1b4dac', '#b50000', '#8cb5ec', '#c1d5f6', '#b3bbe6', '#e5a8a8', '#f9dabe', '#4b91f1', '#8dbdff', '#efeab9',
        '#8a39a7', '#d9cb4f', '#145f89', '#e7d696', '#8592e7', '#e78585', '#92d7c9', '#aeaeb1', '#755c5d', '#7c6ce6',
        '#cc7460', '#bd9331', '#15e1e8', '#514ced', '#8633de', '#eb52b3', '#c4355b', '#6dc779', '#5373a3', '#8dc293'
    ]

    const dynamicHeight = window.innerHeight - 450;
    const options = {
        chart: {
            type: chartType,
            height: dynamicHeight,
            style: {
                fontFamily: "Roboto, Nunito Sans, Arial, Verdana, Helvetica, sans-serif",
            },
            backgroundColor: 'none',
            plotBorderColor: '#e8eaeb',
            plotBorderWidth: chartType != 'pie' && 1,
            events: {
                render: function (this: any) {
                    if (this.plotLeft !== titleLeft) {
                        setTitleLeft(this.plotLeft);
                    }
                },
            },
        },
        colors: ['#2f2282', '#1b51a7', '#3dab97', '#5e3f9e', '#3e88d3', '#1d136a', '#69b8e5', '#3f79ca', '#9e8cc5', '#ed9340',
            '#8cafdf', '#d9914f', '#86c6df', '#3c7df1', '#61cdc0', '#64a1f4', '#dc6161', '#146680', '#2039b5', '#00ad64',
            '#1b4dac', '#b50000', '#8cb5ec', '#c1d5f6', '#b3bbe6', '#e5a8a8', '#f9dabe', '#4b91f1', '#8dbdff', '#efeab9',
            '#8a39a7', '#d9cb4f', '#145f89', '#e7d696', '#8592e7', '#e78585', '#92d7c9', '#aeaeb1', '#755c5d', '#7c6ce6',
            '#cc7460', '#bd9331', '#15e1e8', '#514ced', '#8633de', '#eb52b3', '#c4355b', '#6dc779', '#5373a3', '#8dc293'
        ],
        title: {
            text: ''
        },
        xAxis: {
            categories: barChartData?.map(item => item.name),
            type: 'category',
            title: {
                text: ''
            },
            gridLineDashStyle: 'Dot',
            gridLineWidth: 1,
            labels: {
                style: {
                    // color: '#4c3aff',
                    // cursor: 'pointer',
                    width: '100px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                },
                enabled: chartType != 'pie'
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: chartType !== 'pie' && barChartData?.[0]?.['yAxisLabel']
                    ? `${barChartData?.[0]?.['yAxisLabel']} ${barChartData?.[0]?.['yAxisUnit'] ? ` (${barChartData?.[0]?.['yAxisUnit']})` : ""}`
                    : ""
            },
            labels: {
                format: `{value}`,
                enabled: chartType != 'pie'
            },
            gridLineDashStyle: 'Dot',
            gridLineWidth: 1,
        },
        tooltip: {
            headerFormat: ``,
            pointFormatter: function (this:any) {
                return `<br/><span style="color: #7e8089">${this.name}</span>` +
                       (this.z ? `<br/><span style="color: #7e8089">${this.z}</span>` : '') +
                       `<br/> <b style="color: #fff">${this.y} ${this.yAxisUnit || ''}</b>`;
            },
            valueDecimals: barChartData?.[0]?.['yAxisUnit'] == 'GB' ? 2 : 0,
            borderRadius: 15,
            backgroundColor: '#060606'
        },
        plotOptions: {
            bar: {
                stacking: false,
                grouping: true,
                allowPointSelect: true,
                cursor: 'pointer',
                shadow: false,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                },
                pointWidth: 15,
            },
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                shadow: false,
            },
            column: {
                stacking: false,
                grouping: true
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [{
            data: !_.isEmpty(barChartData) ? barChartData : [],
            dataLabels: {
                enabled: false
            },
            color: '#86c6df',
            size: '80%',
            innerSize: '40%',
        }]
    };

    const handleChartType = (type) => {
        setChartType(type);
        const params = getDecodeURI(location?.search);
        params.chartType = type;
        history.push({ pathname: location.pathname, search: getEncodedURI(params) })
    }

    return (
        <Grid item xs={4.5} sm={4.5} md={4.5} lg={4.5} className="pie-chart-summary">
            <Grid>
                <Grid className="new-summary-control-limit title-toggle-btn-div" mb={1.5}>
                    <Grid className="title-dropdown-pie-chart captive-bar-chart-pagination">
                        <Grid className="captive-line-chart-title" style={{marginLeft: `${titleLeft}px`}}>
                            {barChartData?.[0]?.['title']}
                        </Grid>
                    </Grid>
                    <Grid className="analytics-bar-chart-icons">
                        <img src={BarIcon} className={chartType == 'bar' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleChartType('bar')} alt="bar" style={{ transform: "rotate(90deg) scaleX(-1)" }} />
                        <img src={BarIcon} className={chartType == 'column' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleChartType('column')} alt="bar" />
                        <img src={PieIcon} className={chartType == 'pie' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleChartType('pie')} alt="pie" />
                    </Grid>
                </Grid>
                <Grid container className={chartType == 'pie' ? "hide-axis-line captive-sites-bar-chart" : "captive-sites-bar-chart"} style={{ height: 'calc(100vh - 450px)', overflowY: 'auto', display: 'flex' }}>
                    <Grid item md={chartType == 'pie' ? 6 : 12} lg={chartType == 'pie' ? 6 : 12}>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                        />
                    </Grid>
                    {chartType == 'pie' && <Grid item md={6} lg={6} id='activity-pie-container-2'>
                        <Grid className="usageDetailsWithCategory">
                            {
                                barChartData && barChartData.map((ele, i) => (
                                    <Grid key={i} className="appcategoryUsed-usage">
                                        <div style={{ background: `${colors[i]}` }} className="usageDot-1"></div>
                                        <Grid className="pieChart-activity" id='activity-appcategoryUsed-usage'>
                                            {/* <Grid className="usagepercentage">{barChartData && `${ele.y < 1 ? ele.y < 0.01 && ele.y !== 0 ? 0.01 : Math.round(ele.y * 100) / 100 : Math.round(ele.y)}%`}</Grid> */}
                                            <Grid className="usagepercentage">
                                                {`${Number.isInteger((ele.y / totalUsage) * 100) ? (ele.y / totalUsage) * 100 : ((ele.y / totalUsage) * 100).toFixed(1)}%`}
                                            </Grid>
                                            {/* {categoryIcons ? <GetTopAppsImageCategory app={ele.x.split(' ').join('')} /> : appIcons ? <GetTopAppsImage app={ele.x} /> : null} */}
                                            {ele.tooltip ? <Tooltip title={ele.name} placement={'left-end'}>
                                                <p>{ele.name}</p>
                                            </Tooltip> : (true) ? <Tooltip title={ele.name}><p className="activity-pieChart-app" >{ele.name}</p></Tooltip> : <p>{ele.name}</p>}
                                        </Grid>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>}
                </Grid>
            </Grid>
        </Grid>
    );
}

const mapStateToProps = (state) => ({
    
});

export default withRouter(
  connect(mapStateToProps, { })(AnalyticsBarChart)
);